// Externe Bibliotheken
import React, { Component } from 'react';
import { NavLink } from 'react-router';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import { validateDate } from '@/_helper/dateValidator';
import tracking from '@/_helper/tracking';
import countryList from '@/_data/countryList';
import { getBookingData } from '@/_helper/fetchNewData';
import { getImgPath } from '@/_helper/imageHelper';
import { buildPostRequest } from '@/_helper/apiHelper';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';
import { BackButton } from '@/comp/backButton/backButton';
import Button from '@/comp/button/button.tsx';

// Styles
import './apis.scss';
import { Icon } from '@/comp/icon/icon.tsx';
import { Tooltip } from '@/comp/toolTip/tooltip.tsx';

const params = {
    errorWording: {
        firstName: 'Bitte geben Sie Ihren Vornamen an.',
        lastName: 'Bitte geben Sie Ihren Nachnamen an.',
        travelPassNumber: 'Bitte geben Sie Ihre Reisepassnummer an.',
        exhibitionCountry: 'Bitte geben Sie das Passausstellungsland an.',
        dateOfBirth: 'Bitte geben Sie Ihr Geburtsdatum an.',
        expirationDatePassport: 'Bitte geben Sie das Passgültigkeitsdatum an.',
        nationality: 'Bitte geben Sie Ihre Staatangehörigkeit an.',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
            pageLoad: false,
            countryList: countryList,
            countryQuickList: {
                DE: countryList['DE'],
                AT: countryList['AT'],
                CH: countryList['CH'],
            },
            pageState: '',
            travellersData: {},
            error: false,
            formErrors: [],
            checkedErrors: {
                agb: false,
                privacy: false,
            },
            alreadyTested: false,
            cardValid: [],
            formValid: false,
            formVacancy: false,
            submitSuccess: false,
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.Card = this.Card.bind(this);
    }

    componentDidMount() {
        document.title = 'Reisepassdaten übermitteln' + window.$documentTitle;

        checkIsAllowToBookService('Apis');
        // not allowed to book
        if (
            (this.state.bookingData?.data !== undefined && this.state.bookingData.data.allowApisData === false) ||
            (this.state.bookingData?.data !== undefined && this.state.bookingData.data.gotApisData === true)
        ) {
            window.location.href = '#/';
        }

        if (this.state.bookingData.data !== undefined) {
            if (this.state.bookingData.data.frontendParams.travellers !== undefined) {
                this.setState({
                    travellers: storage.get('bookingData').data.frontendParams.travellers,
                });

                let travellersData = this.state.travellersData;
                let formErrors = this.state.formErrors;
                Object.keys(this.state.bookingData.data.frontendParams.travellers).forEach((k) => {
                    let t = this.state.bookingData.data.frontendParams.travellers[k];
                    formErrors[k] = {};

                    travellersData[k] = {
                        firstName: t.foreName ? t.foreName : '',
                        lastName: t.surName ? t.surName : '',
                        nationality: t.nationality ? this.state.countryList[t.nationality]?.nationality : '',
                        nationalityCode: t.nationality ? t.nationality : '',
                        travelPassNumber: '',
                        exhibitionCountry: t.nationality ? this.state.countryList[t.nationality]?.text : '',
                        exhibitionCountryCode: t.nationality ? t.nationality : '',
                        dateOfBirth: t.birthDate ? t.birthDate : '',
                        gender: t.gender === 'female' ? 'F' : t.gender === 'male' ? 'M' : '',
                        expirationDatePassport: '',
                    };

                    Object.entries(travellersData[k]).forEach((value) => {
                        if (value[0] !== 'exhibitionCountryCode' && value[0] !== 'nationalityCode') {
                            this.validateField(value[0], k, value[1]);
                        }
                    });
                });

                this.setState({
                    pageState: 'loaded',
                    formErrors: formErrors,
                });
            }
        }
        tracking('loaded', 'apis');
        this.clickOutsideHandler();
    }

    handleUserInput(index, event) {
        const target = event.target;
        const value = target.value;
        const name = target.name.slice(18);

        let travellersData = this.state.travellersData;
        let item = { ...travellersData[index] };

        item[name] = value;

        travellersData[index] = item;

        if (name === 'expirationDatePassport') {
            travellersData[index].expirationDatePassport = this.formatDateInput(value);
        }

        if (name === 'dateOfBirth') {
            travellersData[index].dateOfBirth = this.formatDateInput(value);
        }

        this.setState({ travellersData }, () => {
            //call back function of set state
            this.validateField(name, index, value);
        });
    }

    formatDateInput(args) {
        let input = '';
        for (let i = 0; i < args?.length; i++) {
            if (!isNaN(args[i])) {
                if (input.length < 10) {
                    input += args[i];
                }
                if ((i === 1 || i === 4) && i !== args?.length - 1) {
                    input += '.';
                }
            }
        }
        return input;
    }

    resetTrigger(name, index) {
        const onClickResetTrigger = () => {
            let elem = this.state.travellersData;
            elem[index][name] = '';
            if (name === 'exhibitionCountry') {
                elem[index]['exhibitionCountryCode'] = '';
            } else if (name === 'nationality') {
                elem[index]['nationalityCode'] = '';
            }
            this.setState({ travellersData: elem });
            this.validateField(name, index, '');
        };

        if (
            this.state.travellersData[index] !== undefined &&
            this.state.travellersData[index][name] !== undefined &&
            this.state.travellersData[index][name].length
        ) {
            return (
                <div className="reset-trigger" role="button" aria-label="reset eingabe" onClick={onClickResetTrigger}>
                    <Icon name="close" size={18} ariaHidden />
                </div>
            );
        }
    }

    travellers(t) {
        let travellers = [];

        if (t !== undefined && t !== null) {
            Object.keys(t).forEach((k) => {
                travellers.push(<this.Card key={k} t={t[k]} index={k} />);
            });

            return <div className="travellers">{travellers}</div>;
        }
    }

    clickOutsideHandler() {
        document.addEventListener('mousedown', (event) => {
            document.querySelectorAll('.dropdown').forEach((item) => {
                if (item && !item.parentNode.contains(event.target)) {
                    item.classList.add('hide');
                }
            });
        });
    }

    changeFormValid(e) {
        let checkedErrors = this.state.checkedErrors ? this.state.checkedErrors : {};

        checkedErrors[e.target.name] = !!e.currentTarget.checked;

        this.setState(
            {
                checkedErrors: checkedErrors,
            },
            this.validateForm
        );
    }

    validateField(fieldName, index, value) {
        let fieldValidationErrors = this.state.formErrors;
        let valid = false;

        if (value !== undefined) {
            if (fieldValidationErrors[index] === undefined) {
                fieldValidationErrors[index] = {};
            }

            switch (fieldName) {
                case 'exhibitionCountry':
                    valid = value.length > 0;
                    break;
                case 'nationality':
                    valid = value.length > 0;
                    break;
                case 'dateOfBirth':
                    valid = validateDate(value);
                    break;
                case 'expirationDatePassport':
                    valid = validateDate(value);
                    break;
                case 'travelPassNumber':
                    valid = value.length > 4;
                    break;
                default:
                    valid = value.length > 0;
                    break;
            }
        }

        fieldValidationErrors[index][fieldName] = valid ? '' : params.errorWording[fieldName];

        this.setState({ formErrors: fieldValidationErrors }, this.validateForm);
    }

    validateForm() {
        let formValid = true;
        let cardValid = [];
        Object.keys(this.state.formErrors).forEach((index) => {
            cardValid[index] = true;
            Object.keys(this.state.formErrors[index]).forEach((item) => {
                if (this.state.formErrors[index][item] !== '') {
                    cardValid[index] = false;
                    formValid = false;
                }
            });
        });

        Object.keys(this.state.checkedErrors).forEach((index) => {
            if (!this.state.checkedErrors[index]) {
                formValid = false;
            }
        });

        this.setState({ formValid: formValid, cardValid: cardValid });
    }

    handleSubmit(event) {
        event.preventDefault();

        let $this = this;

        this.setState({
            error: false,
            alreadyTested: true,
        });

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            return;
        }

        // form is valid!
        this.setState({
            formVacancy: true,
            error: false,
        });

        let data = this.state.travellersData;

        let sendParams = {
            requestType: 'bookingData',
            clientId: 'customerarea',
            requestSource: 'AurumTours-Customerarea',
            bookingId: storage.get('bookingNumber'),
            action: 'sendApisData',
            hash: storage.get('access_token'),
            data: data,
        };

        axios(buildPostRequest(window.$serviceUrl, '/bookingData', sendParams))
            .then((response) => response)
            .then(function (response) {
                if (response.data.data.statusCode === 200 && response.data.data.errorMessage === null) {
                    getBookingData(storage.get('access_token'))
                        .then(() => {
                            let bookingData = storage.get('bookingData');

                            $this.setState({
                                submitSuccess: true,
                                pageState: 'success',
                                formVacancy: false,
                                bookingData: bookingData,
                            });
                        })
                        .catch(() => {
                            $this.setState({
                                formVacancy: false,
                                pageState: 'error',
                                error: true,
                            });
                        });
                } else {
                    $this.setState({
                        formVacancy: false,
                        pageState: 'error',
                        error: true,
                    });
                }
            })
            .catch((error) => this.setState({ error, formVacancy: false, pageState: 'error' }));
    }

    Card(props) {
        let { index } = props;
        let $this = this;

        const toggleCard = (e) => {
            e.target.closest('.top-head').classList.toggle('open');
        };

        function setExhibitionCountry(event, value) {
            let travellersData = $this.state.travellersData;
            travellersData[index].exhibitionCountry = $this.state.countryList[value].text;
            travellersData[index].exhibitionCountryCode = value;

            $this.setState({
                travellersData: travellersData,
            });

            hideDropdown(event, 'exhibitionCountry');
        }

        function setNationality(event, value) {
            let travellersData = $this.state.travellersData;
            travellersData[index].nationality = $this.state.countryList[value].nationality;
            travellersData[index].nationalityCode = value;

            $this.setState({
                travellersData: travellersData,
            });

            hideDropdown(event, 'nationality');
        }

        function toggleDropdown(event, name) {
            let elem = event.target.closest('.' + name).nextSibling;
            if (elem) {
                elem.classList.toggle('hide');
                if (!elem.classList.contains('hide')) {
                    filterDropdown(event);
                }
            }
        }

        function showDropdown(event, name) {
            let elem = event.target.closest('.' + name).nextSibling;
            if (elem && elem.classList.contains('hide')) {
                elem.classList.remove('hide');
                filterDropdown(event);
            }
        }

        function hideDropdown(event) {
            let elem = event.target.closest('.dropdown');
            if (elem && !elem.classList.contains('hide')) {
                elem.classList.add('hide');
            }
        }

        function filterDropdown(e) {
            let list = countryList;
            let quickList = $this.state.countryQuickList;
            let returnList;
            if (e.target.value === undefined || e.target.value === '') {
                returnList = Object.entries({ ...quickList, ...list });
            } else {
                returnList = Object.entries(list).filter((key) => {
                    return key[1].text.toLowerCase().search(e.target.value.toLowerCase()) !== -1;
                });
            }

            $this.setState({ countryList: Object.fromEntries(returnList) });
        }

        return (
            <section className={`card ${this.state.cardValid[index] ? 'valid' : ''}`}>
                <div className="top-head" onClick={(e) => toggleCard(e, index)}>
                    <div className="main">
                        <Icon name="airplaneTicket" className="color-primary" size={30} ariaHidden />
                        <div className="traveller">
                            <h2>Reisepassdaten für {`${props.t.foreName} ${props.t.surName}`}</h2>
                            {window.$browserInfo.device !== 'mobile' && <span className="dot">&middot;</span>}
                            <span>
                                {' '}
                                {this.state.cardValid[index] ? 'vollständig ausgefüllt' : 'noch nicht ausgefüllt'}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="left">
                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].firstName !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + props.index + '].firstName'}>
                                Vorname
                                <input
                                    id={'travellersData[' + index + '].firstName'}
                                    name={'travellersData[' + index + '].firstName'}
                                    className="with-border"
                                    ref={this.firstName}
                                    type="text"
                                    placeholder="Vorname"
                                    value={this.state.travellersData[index].firstName}
                                    onChange={(event) => this.handleUserInput(index, event)}
                                />
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].firstName !== '' && (
                                <div className="error">{this.state.formErrors[index].firstName}</div>
                            )}
                            {this.resetTrigger('firstName', index)}
                        </div>

                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].lastName !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + props.index + '].lastName'}>
                                {' '}
                                Nachname
                                <input
                                    id={'travellersData[' + props.index + '].lastName'}
                                    name={'travellersData[' + props.index + '].lastName'}
                                    className="with-border"
                                    type="text"
                                    placeholder="Nachname"
                                    value={this.state.travellersData[index].lastName}
                                    onChange={(event) => this.handleUserInput(index, event)}
                                />
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].lastName !== '' && (
                                <div className="error">{this.state.formErrors[index].lastName}</div>
                            )}
                            {this.resetTrigger('lastName', index)}
                        </div>

                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].dateOfBirth !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + index + '].dateOfBirth'}>
                                Geburtstag
                                <input
                                    id={'travellersData[' + index + '].dateOfBirth'}
                                    name={'travellersData[' + index + '].dateOfBirth'}
                                    className="with-border"
                                    type="text"
                                    inputMode="numeric"
                                    placeholder="TT.MM.JJJJ"
                                    value={this.state.travellersData[index].dateOfBirth}
                                    onChange={(event) => this.handleUserInput(index, event)}
                                />
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].dateOfBirth !== '' && (
                                <div className="error">{this.state.formErrors[index].dateOfBirth}</div>
                            )}
                            {this.resetTrigger('dateOfBirth', index)}
                        </div>

                        <div className="input">
                            <label>Geschlecht</label>
                            <div className="radio-group">
                                <div className="radio-selection">
                                    <input
                                        id={'male[' + index + ']'}
                                        type="radio"
                                        name={'travellersData[' + index + '].gender'}
                                        value="M"
                                        defaultChecked={this.state.travellersData[index].gender === 'M'}
                                        onChange={(event) => this.handleUserInput(index, event)}
                                    />
                                    <label className="icon" htmlFor={'male[' + index + ']'}>
                                        <span>Männlich</span>
                                    </label>
                                </div>

                                <div className="radio-selection">
                                    <input
                                        id={'female[' + index + ']'}
                                        type="radio"
                                        name={'travellersData[' + index + '].gender'}
                                        value="F"
                                        defaultChecked={this.state.travellersData[index].gender === 'F'}
                                        onChange={(event) => this.handleUserInput(index, event)}
                                    />
                                    <label className="icon" htmlFor={'female[' + index + ']'}>
                                        <span>Weiblich</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div
                            className={`input ${
                                this.state.alreadyTested && this.state.formErrors[index].exhibitionCountry !== ''
                                    ? ' input-error'
                                    : ''
                            }`}>
                            <label htmlFor={'travellersData[' + index + '].exhibitionCountry'}>
                                Ausstellungsland des Reisepasses
                                <div className={`exhibitionCountry`}>
                                    <span className="countryFlag">
                                        {this.state.travellersData[index].exhibitionCountryCode !== '' && (
                                            <img
                                                src={getImgPath(
                                                    this.state.travellersData[index].exhibitionCountryCode.toLowerCase()
                                                )}
                                                alt={this.state.travellersData[index].exhibitionCountryCode}
                                            />
                                        )}
                                    </span>
                                    <input
                                        id={'travellersData[' + index + '].exhibitionCountry'}
                                        name={'travellersData[' + index + '].exhibitionCountry'}
                                        className={
                                            'with-border' +
                                            (this.state.alreadyTested &&
                                            this.state.formErrors[index].exhibitionCountry !== ''
                                                ? ' input-error'
                                                : '')
                                        }
                                        data-country-code={this.state.travellersData[index].exhibitionCountryCode}
                                        type="text"
                                        placeholder="Ausstellungsland des Reisepasses"
                                        value={this.state.travellersData[index].exhibitionCountry}
                                        onChange={(event) => {
                                            showDropdown(event, 'exhibitionCountry');
                                            this.handleUserInput(index, event);
                                            filterDropdown(event, countryList.countryList);
                                        }}
                                    />
                                    {this.state.travellersData[index].exhibitionCountry === '' ? (
                                        <span
                                            className="arrow"
                                            role="button"
                                            aria-label="dropdown öffnen"
                                            onClick={(event) => {
                                                toggleDropdown(event, 'exhibitionCountry');
                                            }}>
                                            <Icon name="keyboardArrowDown" ariaHidden />
                                        </span>
                                    ) : (
                                        this.resetTrigger('exhibitionCountry', index)
                                    )}
                                </div>
                                <div className="dropdown hide">
                                    <div className="cnt dropdown-content">
                                        {Object.keys(this.state.countryList).map((value, listIndex) => {
                                            if (
                                                $this.state.countryList[value].text &&
                                                $this.state.countryList[value].text !== ''
                                            ) {
                                                return (
                                                    <div
                                                        className={`line`}
                                                        key={listIndex}
                                                        data-code={value}
                                                        onClick={(event) => {
                                                            setExhibitionCountry(event, value);
                                                            this.validateField('exhibitionCountry', index, value);
                                                        }}>
                                                        <img
                                                            className="flag"
                                                            data-flag={value.toLowerCase()}
                                                            src={getImgPath(value.toLowerCase())}
                                                            alt={value}
                                                        />
                                                        {$this.state.countryList[value].text}
                                                    </div>
                                                );
                                            } else {
                                                return <React.Fragment key={listIndex}></React.Fragment>;
                                            }
                                        })}
                                    </div>
                                </div>
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].exhibitionCountry !== '' && (
                                <div className="error">{this.state.formErrors[index].exhibitionCountry}</div>
                            )}
                        </div>

                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].nationality !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + index + '].nationality'}>
                                Staatsangehörigkeit
                                <div className={`nationality`}>
                                    <span className="countryFlag">
                                        {this.state.travellersData[index].nationalityCode !== '' && (
                                            <img
                                                src={getImgPath(
                                                    this.state.travellersData[index].nationalityCode.toLowerCase()
                                                )}
                                                alt={this.state.travellersData[index].nationalityCode}
                                            />
                                        )}
                                    </span>
                                    <input
                                        id={'travellersData[' + index + '].nationality'}
                                        name={'travellersData[' + index + '].nationality'}
                                        className="with-border"
                                        type="text"
                                        placeholder="Staatsangehörigkeit"
                                        value={this.state.travellersData[index].nationality}
                                        onChange={(event) => {
                                            showDropdown(event, 'nationality');
                                            this.handleUserInput(index, event);
                                            filterDropdown(event, countryList);
                                        }}
                                    />

                                    {this.state.travellersData[index].nationality === '' ? (
                                        <span
                                            className="arrow"
                                            role="button"
                                            aria-label="dropdown öffnen"
                                            onClick={(event) => {
                                                toggleDropdown(event, 'nationality');
                                            }}>
                                            <Icon name="keyboardArrowDown" ariaHidden />
                                        </span>
                                    ) : (
                                        this.resetTrigger('nationality', index)
                                    )}
                                </div>
                                <div className="dropdown hide">
                                    <div className="cnt dropdown-content">
                                        {Object.keys(this.state.countryList).map((value, listIndex) => {
                                            if (
                                                $this.state.countryList[value].nationality &&
                                                $this.state.countryList[value].nationality !== ''
                                            ) {
                                                return (
                                                    <div
                                                        className={`line`}
                                                        key={listIndex}
                                                        data-code={value}
                                                        onClick={(event) => {
                                                            setNationality(event, value);
                                                            this.validateField('nationality', index, value);
                                                        }}>
                                                        <img
                                                            className="flag"
                                                            src={getImgPath(value.toLowerCase())}
                                                            alt={this.state.countryList[value].text}
                                                        />
                                                        {$this.state.countryList[value].nationality}
                                                    </div>
                                                );
                                            } else {
                                                return <React.Fragment key={listIndex}></React.Fragment>;
                                            }
                                        })}
                                    </div>
                                </div>
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].nationality !== '' && (
                                <div className="error">{this.state.formErrors[index].nationality}</div>
                            )}
                        </div>

                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].travelPassNumber !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + index + '].travelPassNumber'}>
                                <div>
                                    Reisepassnummer
                                    <Tooltip placement={window.$browserInfo.device === 'mobile' ? 'auto' : 'right'}>
                                        Die neunstellige Seriennummer deutscher Reisepässe befindet sich in der oberen,
                                        rechten Ecke des Reisepasses.
                                    </Tooltip>
                                </div>
                                <input
                                    id={'travellersData[' + index + '].travelPassNumber'}
                                    name={'travellersData[' + index + '].travelPassNumber'}
                                    className="with-border"
                                    type="text"
                                    placeholder="Reisepassnummer"
                                    value={this.state.travellersData[index].travelPassNumber}
                                    onChange={(event) => this.handleUserInput(index, event)}
                                />
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].travelPassNumber !== '' && (
                                <div className="error">{this.state.formErrors[index].travelPassNumber}</div>
                            )}
                            {this.resetTrigger('travelPassNumber', index)}
                        </div>

                        <div
                            className={
                                'input' +
                                (this.state.alreadyTested && this.state.formErrors[index].expirationDatePassport !== ''
                                    ? ' input-error'
                                    : '')
                            }>
                            <label htmlFor={'travellersData[' + index + '].expirationDatePassport'}>
                                Gültig bis
                                <input
                                    id={'travellersData[' + index + '].expirationDatePassport'}
                                    name={'travellersData[' + index + '].expirationDatePassport'}
                                    className="with-border"
                                    type="text"
                                    inputMode="numeric"
                                    placeholder="TT.MM.JJJJ"
                                    value={this.state.travellersData[index].expirationDatePassport}
                                    onChange={(event) => this.handleUserInput(index, event)}
                                />
                            </label>
                            {this.state.alreadyTested && this.state.formErrors[index].expirationDatePassport !== '' && (
                                <div className="error">{this.state.formErrors[index].expirationDatePassport}</div>
                            )}
                            {this.resetTrigger('expirationDatePassport', index)}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const { travellers } = this.state;

        return (
            <div className="page-apis redesign">
                <Header />

                {this.state.pageState === 'error' ? (
                    <StatusPage subPage="apis" type="error" />
                ) : this.state.pageState === 'success' ? (
                    <StatusPage subPage="apis" type="success" />
                ) : (
                    <>
                        <div className="content-wrapper">
                            <div className="page-content">
                                <div className="intro">
                                    <h1 className="main-headline">Ihre Reisepassdaten</h1>
                                    <div className="info">
                                        <Icon name="info" ariaHidden />
                                        Wir empfehlen Ihnen vorab die Daten aller Mitreisenden zusammenzutragen, da das
                                        Formular nur einmalig ausgefüllt werden kann.
                                    </div>
                                </div>

                                <form
                                    className={' ' + (this.state.formVacancy ? 'validate' : '')}
                                    autoComplete="off"
                                    onSubmit={this.handleSubmit}
                                    method="post"
                                    noValidate=""
                                    onChange={() => {
                                        tracking('interaction', 'apis');
                                    }}>
                                    {this.travellers(travellers)}

                                    <div className="accept-sec">
                                        <div className="row agb-input">
                                            <input
                                                type="checkbox"
                                                name="agb"
                                                id="agb-checkbox"
                                                onChange={(e) => {
                                                    this.changeFormValid(e);
                                                }}
                                            />
                                            <label htmlFor="agb-checkbox">
                                                Wir weisen darauf hin, dass dieses Formular nur einmal abgesendet werden
                                                kann. Bitte prüfen Sie daher Ihre Angaben ein letztes Mal auf
                                                Richtigkeit und Vollständigkeit.
                                            </label>
                                        </div>
                                        <div className="row privacy-input">
                                            <input
                                                type="checkbox"
                                                name="privacy"
                                                id="privacy-checkbox"
                                                onChange={(e) => {
                                                    this.changeFormValid(e);
                                                }}
                                            />
                                            <label htmlFor="privacy-checkbox">
                                                Durch das Absenden Ihrer Daten sind Sie damit einverstanden, dass wir
                                                diese unter Einhaltung der Datenschutzrechtlinien an die
                                                Fluggesellschaft weitergeben. Sie sind außerdem damit einverstanden,
                                                dass wir Ihre Daten nach Datenschutzrechtlinie speichern und
                                                verarbeiten. Hier finden Sie unsere{' '}
                                                <NavLink to="/datenschutz" target="_blank">
                                                    Datenschutzhinweise
                                                </NavLink>{' '}
                                                und{' '}
                                                <a
                                                    href={`${window.$website}/unternehmen/agb`}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    AGBs
                                                </a>
                                                .
                                            </label>
                                        </div>
                                        {this.state.alreadyTested &&
                                            (this.state.checkedErrors['agb'] === false ||
                                                this.state.checkedErrors['privacy'] === false) && (
                                                <p className="error">
                                                    Um das Formular abschicken zu können, müssen Sie die
                                                    Datenschutzhinweise und Allgemeinen Geschäftsbedingungen
                                                    akzeptieren.
                                                </p>
                                            )}
                                    </div>

                                    <div className="user-action">
                                        <BackButton class="col" target="blank" />

                                        <Button
                                            valid={this.state.formValid}
                                            validated={this.state.formVacancy}
                                            type="submit"
                                            label={
                                                this.state.formVacancy
                                                    ? 'Reisepassdaten werden abgeschickt'
                                                    : 'Reisepassdaten abschicken'
                                            }
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        {window.$browserInfo.device !== 'mobile' ? (
                            <a
                                className="info-button"
                                href="https://www.bmi.bund.de/SharedDocs/faqs/DE/themen/moderne-verwaltung/reisepass/reisepass-faq.html"
                                rel="noopener noreferrer"
                                target="_blank">
                                <i className="icon icon-tip-lightbulb"></i>
                                <div className="description">
                                    NOCH FRAGEN?
                                    <br />
                                    <span className="text-underline">Reisepass FAQ</span>
                                </div>
                            </a>
                        ) : (
                            <div className="info-button">
                                <i className="icon icon-tip-lightbulb"></i>
                                <div className="description">
                                    NOCH FRAGEN?
                                    <br />
                                    <a
                                        href="https://www.bmi.bund.de/SharedDocs/faqs/DE/themen/moderne-verwaltung/reisepass/reisepass-faq.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-underline">
                                        Reisepass FAQ
                                    </a>
                                </div>
                            </div>
                        )}
                    </>
                )}

                <Footer />
            </div>
        );
    }
}

export default Index;
